
import React from 'react';
import { Heart } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 py-12 bg-white dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <div className="text-slate-400 text-sm">
          &copy; {new Date().getFullYear()} Kim Vincent Alday. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
